<div class="modal-header">
  <span class="modal-title">{{ title ? title : 'CREATE CASE CONFIGURATION'}}</span>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.close()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<form [formGroup]="configForm">
  <div class="modal-body">
    <div class="d-flex align-items-start" *ngIf="prodData">
      <img width="40" height="40" [src]="imageUrl + (prodData.productId || prodData.id)">
      <div class="kt-padding-l-15">
        <div class="strong main-col-14">
          {{ prodData.title || prodData.description }}
        </div>
        <div class="content-text-13 kt-padding-t-5 kt-padding-b-10">
          <span class="kt-padding-r-15">S: {{ prodData.sku }}</span>
          <span class="kt-padding-r-15">A: {{ prodData.listingId }}</span>
          <span class="kt-padding-r-15">U: {{ prodData.upc }}</span>
        </div>
      </div>
    </div>
    <div class="kt-margin-t-25">
      <div class="sub-title-14 kt-margin-b-10">
        {{ 'SETTING.LABELS.BOX_CONFIG' | translate }}
      </div>
      <input type="text" formControlName="name" class="form-control">
    </div>
    <div class="kt-margin-t-30 d-flex align-items-start justify-content-between">
      <div class="units-per-box" *ngIf="prodData">
        <div class="sub-title-14 kt-margin-b-10">{{ 'PRODUCT_REORDER.LABEL.UNITS_PER_BOX' | translate }}</div>
        <input type="number" formControlName="quantity" class="form-control">
      </div>
      <div class="box-dimensions">
        <div class="sub-title-14 kt-margin-b-10">{{ 'PRODUCT_REORDER.LABEL.BOX_DIMENSIONS' | translate }}</div>
        <div class="w-100 d-flex align-items-center">
          <div class="kt-margin-r-5"><input type="number" formControlName="width" class="form-control"></div> X
          <div class="kt-margin-l-5 kt-margin-r-5"><input type="number" formControlName="height" class="form-control">
          </div> X
          <div class="kt-margin-l-5"><input type="number" formControlName="depth" class="form-control"></div>
        </div>
      </div>
      <div class="box-weight" *ngIf="prodData">
        <div class="sub-title-14 kt-margin-b-10">{{ 'PRODUCT_REORDER.LABEL.BOX_WEIGHT' | translate }}</div>
        <input type="number" formControlName="weight" class="form-control">
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button class="btn btn-secondary bg-white"
      (click)="activeModal.close()">{{ 'GENERAL.BUTTONS.CANCEL' | translate }}</button>
    <button class="btn btn-brand kt-margin-l-15"
      (click)="submit()">{{ 'GENERAL.BUTTONS.SAVE' | translate }}</button>
  </div>
</form>
<loading></loading>
